











import { defineComponent } from "@vue/composition-api";
import PageTitle from "@c/atoms/app/PageTitle.vue";

export default defineComponent({
  name: "Contact",

  components: {
    PageTitle
  },

  setup() {
    return {};
  }
});
